import React, { useEffect } from 'react';
import DataPlatformGuide from '../../../portal/src/pages/DataPlatformGuide';
import BrandHeader from '../components/BrandHeader';
import { getBrandConfig } from '../brand-config';

const DataPlatformPage: React.FC = () => {
  const brandConfig = getBrandConfig();
  const aiCenterBaseUrl =
    brandConfig.apps.find((app) => app.id === 'ai-center')?.path || '/ai-center';
  const aiCenterPath = (path: string) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${aiCenterBaseUrl.replace(/\/+$/, '')}${normalizedPath}`;
  };
  const brandSite =
    brandConfig.name === 'Mars Men'
      ? 'https://mengotomars.com'
      : brandConfig.name === 'Hollow Socks'
        ? 'https://hollowsocks.com'
        : 'https://easystreetbrands.com';

  useEffect(() => {
    document.title = `Data Platform — ${brandConfig.name}`;
  }, [brandConfig.name]);

  return (
    <div className="app" style={{ '--primary-color': brandConfig.primaryColor } as React.CSSProperties}>
      <DataPlatformGuide
        theme={brandConfig.name === 'Mars Men' ? 'marsmen' : 'portal'}
        headerSlot={
          <BrandHeader />
        }
        heroKicker={`${brandConfig.name} data platform`}
        heroTitle={`Where ${brandConfig.name} should go for data`}
        heroSubtitle={`The operating map for ${brandConfig.name}: source systems, AWS data lake and warehouse layers, reporting surfaces, and the rules for choosing the right source of truth.`}
        footerText={`© 2026 ${brandConfig.name}. Internal data and automation guide.`}
        footerLinks={[
          { label: brandConfig.name, href: brandSite },
        ]}
        aiCenterNavigationHandlers={
          brandConfig.name === 'Mars Men'
            ? {
                openHome: () => { window.location.href = aiCenterBaseUrl; },
                openDepartments: () => { window.location.href = aiCenterPath('/departments'); },
                openBuilderPatterns: () => { window.location.href = aiCenterPath('/guides/builder-patterns'); },
              }
            : undefined
        }
      />
    </div>
  );
};

export default DataPlatformPage;
